export default __webpack_public_path__ + "static/compsych-0ee357498243c65669cb6829787dbc15.svg";